import { render, staticRenderFns } from "./quizTC.vue?vue&type=template&id=3b970066&scoped=true&"
import script from "./quizTC.vue?vue&type=script&lang=js&"
export * from "./quizTC.vue?vue&type=script&lang=js&"
import style0 from "./quizTC.vue?vue&type=style&index=0&id=3b970066&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b970066",
  null
  
)

export default component.exports